<template>
  <div id="app" class="slash-application">
    <img :src="require('@/assets/images/logo.png')" alt="App Logo" />
  </div>
</template>

<script>
export default {
  name: "Slash",
};
</script>

<style scoped>
.slash-application {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: var(--white);
}

.slash-application img {
  max-height: 100px;
  width: auto;
  /* filter: grayscale(0%) contrast(100%); */
  opacity: 0.5;
}
</style>
